import { render, staticRenderFns } from "./InputProducts.vue?vue&type=template&id=a97614aa&scoped=true"
import script from "./InputProducts.vue?vue&type=script&lang=js"
export * from "./InputProducts.vue?vue&type=script&lang=js"
import style0 from "./InputProducts.vue?vue&type=style&index=0&id=a97614aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97614aa",
  null
  
)

export default component.exports